var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { Card } from "../Layout";
import { H2 } from "../Headings";
export var Main = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  z-index: 20;\n  min-height: calc(100vh - 290px);\n  padding-bottom: 100px;\n  background: ", ";\n  ", "\n  ", "\n  ", "\n  &.hidden-nav {\n      height: 100%;\n      min-height: 100%;\n  }\n"], ["\n  position: relative;\n  z-index: 20;\n  min-height: calc(100vh - 290px);\n  padding-bottom: 100px;\n  background: ", ";\n  ", "\n  ", "\n  ", "\n  &.hidden-nav {\n      height: 100%;\n      min-height: 100%;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.lightest;
}, function (_a) {
    var marginTop = _a.marginTop, theme = _a.theme;
    return marginTop && "margin-top: " + theme.spacing.six + ";";
}, function (_a) {
    var flush = _a.flush;
    return flush && "padding-bottom: 0;";
}, function (_a) {
    var mainBackground = _a.mainBackground;
    return mainBackground && "background: " + mainBackground + ";";
});
export var StyledCard = styled(Card)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-top: 150px;\n  text-align: center;\n"], ["\n  margin-top: 150px;\n  text-align: center;\n"])));
export var Picture = styled.img(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  box-shadow: ", ";\n  width: 100px;\n  height: 100px;\n  border: 2px solid ", ";\n  border-radius: 50%;\n  background-color: #f1f1f1;\n  margin: -80px auto 0;\n  position: relative;\n  overflow: hidden;\n"], ["\n  box-shadow: ", ";\n  width: 100px;\n  height: 100px;\n  border: 2px solid ", ";\n  border-radius: 50%;\n  background-color: #f1f1f1;\n  margin: -80px auto 0;\n  position: relative;\n  overflow: hidden;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.shadows.low;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.white;
});
export var StyledH2 = styled(H2)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  padding: 30px 15px;\n"], ["\n  padding: 30px 15px;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
